import Axios, { InternalAxiosRequestConfig } from "axios";

import { env } from "@/config/env";
import applyCaseMiddleware from "axios-case-converter";

function authRequestInterceptor(config: InternalAxiosRequestConfig) {
  const token = localStorage.getItem("token");
  config.headers = config.headers || {};
  config.headers.Accept = "application/json";
  if (token) {
    config.headers.Authorization = token;
  }
  return config;
}

export const api = applyCaseMiddleware(
  Axios.create({
    baseURL: `${env.API_URL}/generative_marketing`
  })
);

api.interceptors.request.use(authRequestInterceptor);
api.interceptors.response.use(undefined, (error) => {
  if (error.response?.status === 401) {
    localStorage.removeItem("token");
    return Promise.reject(new Error("Unauthorized"));
  }
  return Promise.reject(error);
});
